"use client";

import dynamic from "next/dynamic";

export const DynamicEmailCapture = dynamic(
	() =>
		import("@/components/email-capture-modal").then(
			(mod) => mod.EmailCaptureModal,
		),
	{ ssr: false },
);

export const DynamicSearchCommand = dynamic(
	() =>
		import("@/components/search/search-command").then(
			(mod) => mod.SearchCommand,
		),
	{ ssr: false },
);

export const DynamicAnnouncementBarUI = dynamic(
	() =>
		import("@/components/layout/announcement-bar-client").then(
			(mod) => mod.AnnouncementBarClient,
		),
	{ ssr: false },
);

export const DynamicCookieConsent = dynamic(
	() =>
		import("@/components/cookie-consent").then(
			(mod) => mod.CookieConsentBanner,
		),
	{ ssr: false },
);

export const DynamicHomePopupUI = dynamic(
	() =>
		import("@/components/home/home-popup-client").then(
			(mod) => mod.default || mod.HomePopupClient,
		),
	{ ssr: false },
);
